export class StorageKey {
    static readonly AUTH= 'b2b-auth';
}

export class AppSettings
{
};

